import React from 'react';
import TimedealProductCard from './TimedealProductCard';
import { TimedealWidgetDetailV2, TimedealWidgetItem } from '../../../../../../../types/widget';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import WidgetPreviewTimedealInfo from '../WigetPreviewTimedealInfo';
import { TimedealSwipeWrapperStyle, NoticeText, NoticeWrapper } from './style';

interface WidgetPreviewTimedealSwipeProps {
  detail: TimedealWidgetDetailV2;
}
const TimedealWidgetSwipeLayout = (props: WidgetPreviewTimedealSwipeProps): JSX.Element => {
  const { detail } = props;

  return (
    <TimedealSwipeWrapperStyle>
      <NoticeWrapper>
        <NoticeText>※ 타임딜 위젯 미리보기에 노출 되는 금액은 실제 고객들에게 보여지는 금액과 상이합니다.</NoticeText>
        <NoticeText>
          ※ 위젯 미리보기를 통해 배너 이미지 / 메인 타이틀 / 쿠폰 적용 여부에 대해서만 확인 부탁드립니다.
        </NoticeText>
      </NoticeWrapper>
      <WidgetPreviewTimedealInfo title={detail.mainTitle} subTitle={detail.subTitle} />
      <Slider
        list={detail.widgetItemTimeDealList}
        arrows={false}
        infinite={false}
        item={(widgetItem: TimedealWidgetItem) => <TimedealProductCard widgetItem={widgetItem} />}
      />
    </TimedealSwipeWrapperStyle>
  );
};

export default TimedealWidgetSwipeLayout;
